import React, { useEffect, useRef } from "react";
import { View, Image, Dimensions, BackHandler, Alert } from "react-native";
import { useFocusEffect } from "@react-navigation/native";
import { NON_SERVICEABLE_EVENTS } from "@constants/analyticsEventsCT";
import analytics from "@services/analytics";
import { useDispatch, useSelector } from "react-redux";
import withLocation from "@utils/withLocation";
import styles from "./styles";
import Button from "./Components/Button";
import t from "@constants/localization";
import CityMallTextLogo from "@assets/svg/Jrny/CityMallTextLogo";

const PATH = "screens/LocationServiceablity/NotServiceable";
const { width: screenWidth } = Dimensions.get("screen");

const NotServiceable = ({ navigation, route, ...props }) => {
  const backHandler = useRef();
  const backClickCount = useRef(0);
  const dispatch = useDispatch();
  const { address1 } = useSelector(({ auth = {} }) => auth?.user ?? {});

  useFocusEffect(
    React.useCallback(() => {
      backHandler.current = BackHandler.addEventListener(
        "hardwareBackPress",
        goingBackHandler,
      );
      return () => backHandler.current.remove();
    }, []),
  );

  useEffect(() => {
    analytics.trackEvent(NON_SERVICEABLE_EVENTS.LANDING);
  }, []);

  const goingBackHandler = () => {
    if (backClickCount.current === 1) {
      Alert.alert(
        t(`${PATH}/exit`),
        t(`${PATH}/cnfmExit`),
        [
          {
            onPress: () => BackHandler.exitApp(),
            text: t(`${PATH}/yes`),
          },
          {
            style: "cancel",
            text: t(`${PATH}/no`),
            onPress: () => {
              backClickCount.current = 0;
            },
          },
        ],
        { cancelable: false },
      );
      return true;
    }
    backClickCount.current++;
    return true;
  };

  const handleChangeLocation = () => {
    analytics.trackEvent(NON_SERVICEABLE_EVENTS.CHANGE_LOCATION);
    let params = route.params || {};
    if (address1) {
      navigation.navigate("LocationViaAddress", {
        ...params,
      });
      // navigation.navigate("HomeStack", {
      //   screen: "LocationViaAddress",
      // });
    } else {
      navigation.navigate("LocationViaAddress", {
        ...params,
      });
    }
  };

  return (
    <View
      style={{
        backgroundColor: "white",
        flex: 1,
        padding: 20,
      }}
    >
      <CityMallTextLogo width={120} height={25} />
      <View
        style={{
          justifyContent: "center",
          flex: 1,
          paddingBottom: 50,
        }}
      >
        <Image
          source={require("../../assets/images/ServiceNotAvailable.jpeg")}
          resizeMode="contain"
          style={{
            height: undefined,
            width: screenWidth - 10,
            aspectRatio: 360 / 228.63,
            marginTop: 100,
            alignSelf: "center",
          }}
        />
        <Button
          btnText={t(`${PATH}/changeLocation`)}
          style={[styles.btnStyle, { width: screenWidth - 40 }]}
          contentContainerStyle={{
            alignItems: "center",
            marginTop: 40,
            marginBottom: 20,
          }}
          onPress={handleChangeLocation}
        />
      </View>
    </View>
  );
};

export default withLocation(NotServiceable, {
  fromNotServiceable: true,
});
